import Text from '@deprecated-ui/common/Text';
import Image from 'global/Image';
import Link from 'next/link';
import { Item, Description, Title } from '../styled';
import features from './constants';
import {
  FeatureContainer,
  FeatureList,
  FeatureSidebar,
  ProceedLink,
} from './styled';

const MulaiInvestasiFeatures = () => (
  <FeatureContainer>
    <FeatureSidebar>
      <Title>Fitur Investasi Terlengkap</Title>
      <Description size="16px">
        Pertajam analisis Anda dalam berinvestasi dengan fitur-fitur
        professional. Tingkatkan potensi untuk mendapatkan keuntungan yang
        maksimal.
      </Description>
      <Link href="/info/pro-tools">
        <ProceedLink>Pelajari Lebih Lanjut</ProceedLink>
      </Link>
    </FeatureSidebar>
    <FeatureList>
      {features.map((b) => (
        <Item key={b.title}>
          <Image src={b.image} />
          <Text size="19px" family="bold" as="h2">
            {b.title}
          </Text>
          <Description
            size="16px"
            dangerouslySetInnerHTML={{
              __html: b.desc,
            }}
          />
        </Item>
      ))}
    </FeatureList>
  </FeatureContainer>
);

export default MulaiInvestasiFeatures;
